import { render, staticRenderFns } from "./FileCard.vue?vue&type=template&id=748fec44&scoped=true"
import script from "./FileCard.vue?vue&type=script&lang=js"
export * from "./FileCard.vue?vue&type=script&lang=js"
import style0 from "./FileCard.vue?vue&type=style&index=0&id=748fec44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748fec44",
  null
  
)

export default component.exports